import axios from 'axios'
import Utils from '@/common/Utils'

const url = `${process.env.VUE_APP_BASEPATH}/api`
const headers = { 'Content-Type': 'application/json' }

export default class UserSupervisionService {
    static async getPromotersByPaymentCollector (id) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/userSupervisions/getPromotersByPaymentCollector/${id}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }

    static async getCreditsByPaymentCollector (id) {
        try {
            headers['Authorization'] = await Utils.setLocalToken()
            let { data } = await axios.get(`${url}/userSupervisions/getCreditsByPaymentCollector/${id}`, { headers })
            return Promise.resolve(data)
        } catch (error) {
            console.error(error)
            return Promise.reject(error)
        }
    }
}
